import type { TTSProvider } from './tts-types';

export class WebSpeechTTSProvider implements TTSProvider {
  onStart?: () => void;
  onEnd?: () => void;

  private synth: SpeechSynthesis;
  private currentUtterance: SpeechSynthesisUtterance | null = null;

  constructor() {
    this.synth = window.speechSynthesis;
  }

  async prepare(): Promise<void> {
    try { window.speechSynthesis?.cancel(); } catch (_e) { /* ignore */ }
  }

  async speak(text: string): Promise<void> {
    this.stop();
    return this.speakChunk(text);
  }

  private speakChunk(text: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const utterance = new SpeechSynthesisUtterance(text);
      this.currentUtterance = utterance;

      utterance.onstart = () => {
        this.onStart?.();
      };

      utterance.onend = () => {
        this.currentUtterance = null;
        resolve();
      };

      utterance.onerror = (e) => {
        this.currentUtterance = null;
        if (e.error === "canceled") {
          resolve();
        } else {
          reject(new Error(`TTS error: ${e.error}`));
        }
      };

      this.synth.speak(utterance);
    });
  }

  stop(): void {
    const wasActive = this.currentUtterance !== null || this.synth.speaking;
    this.synth.cancel();
    this.currentUtterance = null;
    if (wasActive) {
      this.onEnd?.();
    }
  }

  duck(): void {
    // WebSpeech has no volume control — no-op
  }

  unduck(): void {
    // WebSpeech has no volume control — no-op
  }

  dispose(): void {
    this.stop();
  }

  isSpeaking(): boolean {
    return this.synth.speaking;
  }

}
